import { render, staticRenderFns } from "./article-keywords.vue?vue&type=template&id=e0a54468"
import script from "./article-keywords.vue?vue&type=script&lang=js"
export * from "./article-keywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports